import React from 'react';

export default function CurrencyAmount({ classNames, amount, symbol = '$' }) {
  const currencySymbol = symbol || '$';

  return (
    <span className={classNames}>
      {currencySymbol}
      {amount || 0}
    </span>
  );
}
